var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11.759,
    viewBox: "0 0 14 11.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_button",
    "data-name": "Menu button",
    transform: "translate(-343 -64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(55 -691)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 14,
    height: 1.759,
    rx: 0.879,
    transform: "translate(288 755)",
    fill: "#1a1824"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 14,
    height: 1.759,
    rx: 0.879,
    transform: "translate(288 760)",
    fill: "#1a1824"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1875",
    "data-name": "Rectangle 1875",
    width: 7,
    height: 1.759,
    rx: 0.879,
    transform: "translate(288 765)",
    fill: "#1a1824"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.d6e4498c841fc30706a2b73d63d356d8.svg";
export { ForwardRef as ReactComponent };